const {
  dosageForms,
  unitTypes,
  medicationGroups,
} = require('../config/medication');

function medicationLabel(dosageFormType, group, concentration, { includeGroup = false, customGroups = [] } = {}) {
  const df = dosageForms.find(form => form.key === dosageFormType);
  
  const units1 = unitTypes.find(unit => unit.key === concentration.numeratorUnits);
  let groupLabel = '';
  if (includeGroup) {
    const medGroup = medicationGroups.concat(customGroups).find(g => g.key === group);
    groupLabel = medGroup ? `${medGroup.label.en}` : '';
  }
  if (df.unitType2) {
    const units2 = unitTypes.find(unit => unit.key === df.unitType2);
    return `${groupLabel} ${df.label.en} (${concentration.numeratorValue}${units1.label.en}/${units2.label.en})`.trim();
  } else if (df.key === 'SUSPENSION' || df.key === 'SOLUTION') {
    const denominatorValue = +concentration.denominatorValue !== 1 ? concentration.denominatorValue : '';
    return `${groupLabel} ${df.label.en} (${concentration.numeratorValue}${units1.label.en}/${denominatorValue}mL)`.trim();
  }
  return 'N/A';
}

module.exports = medicationLabel;
